








































import AbpBase from "@/lib/abpbase";
import { Component, Prop } from "vue-property-decorator";
import { GetListByCode } from "@/api/configureDictionary";
import { GetKnowledgeList } from "@/api/pdOutPatient/pdEducation/pdKnowledge";
@Component
export default class extends AbpBase {
  @Prop() value: boolean;
  @Prop() data: string;
  knowledgeGroup: any[] = [];
  queryCondition: any = {
    idListStr: ""
  };
  knowledgeList: any = [];
  loading: boolean = false;
  columns = [
    {
      type: "selection",
      width: 60,
      align: "center"
    },
    {
      title: "教材名称",
      key: "name"
    },
    {
      title: "教材分类",
      key: "groupName"
    },
    {
      title: "适用分期",
      key: "ckd",
      render: (h: any, p: any) => {
        let ckd = "";
        switch (p.row.ckd) {
          case 1:
            ckd = "G1期";
            break;
          case 2:
            ckd = "G2期";
            break;
          case 3:
            ckd = "G3a期";
            break;
          case 4:
            ckd = "G3b期";
            break;
          case 5:
            ckd = "G4期";
            break;
          case 6:
            ckd = "G5期";
            break;
          case 99:
            ckd = "未分期";
            break;
        }
        return h("span", {}, ckd);
      }
    }
  ];

  created() {
    this.initDic();
    this.getData();
  }

  async initDic() {
    let res = await GetListByCode({ input: "PD_Knowledge_Group" });
    this.knowledgeGroup = res;
  }

  visibleChange(value: boolean) {
    if (!value) {
      this.$emit("input", value);
    }
  }

  cancel() {
    this.$emit("input", false);
  }

  async save() {
    let selectedRows = (this.$refs.knowledgeTable as any).getSelection();
    if (selectedRows.length == 0) {
      this.$Message.error("请选择宣教材料！");
      return;
    }
    this.$emit("on-success",{data:selectedRows});
    this.$emit("input", false);
  }

  async getData() {
    this.loading = true;
    this.queryCondition.idListStr = this.data;
    let res = await GetKnowledgeList(this.queryCondition);
    this.knowledgeList = res.objects;
    this.loading = false;
  }
}



// WEBPACK FOOTER //
// ./node_modules/vue-loader/lib/selector.js?type=script&index=0!./src/views/pdOutPatient/pdEducation/pdEducationModel/addKnowledge.vue